if(document.getElementsByClassName("cta-meta-json").length <= 0){
  var ctaShop = typeof Shopify !== 'undefined' ? Shopify.shop : document.domain;
  
  var ctaShopDomain = document.domain;
  
  var ctaBasePath = 'https://' + ctaShopDomain + '/a/cta/';
  
  var ctaHead = document.getElementsByTagName('head')[0];
  
  var ctaAppSettings = "";
  
  var ctaDefaultImage = ctaBasePath+'images/Unknown_person.jpg';
  
  var ctaReadmoreHTML = '<span class="cta-read-more">Read More</span>';

  var ctaImageBasepath = 'https://shopify-apps.nyc3.cdn.digitaloceanspaces.com/testimony/';


  //LOAD Setting JSON
  var ctaJsonTag = document.querySelector("[ctajson]");
  if (typeof (ctaJsonTag) != 'undefined' && ctaJsonTag != null) {
    ctaAppSettings = JSON.parse(ctaJsonTag.innerHTML);
  }
  
  function ctaRunWithJQuery(ctaLoadMain) {
  
    if (typeof jQuery == "undefined") {
  
      var ctaHead = document.getElementsByTagName('head')[0];
  
      var ctaScript = document.createElement('script');
  
      ctaScript.src = ctaBasePath + "js/lib/jquery-3.4.1.min.js";
  
      ctaScript.type = "text/javascript";
  
      ctaScript.onreadystatechange = ctaLoadMain;
  
      ctaScript.onload = ctaLoadMain;
  
      ctaHead.appendChild(ctaScript);
  
    } else {
      ctaLoadMain();
    }
  
  }
  
  ctaRunWithJQuery(function ctaLoadMain() {
    (function ($ctajobject, window, document) {
  
      $ctajobject.fn.ctaLoad = function () {
        this.ctaHandler();
      };
  
      $ctajobject.fn.ctaHandler = function () {
        //get all the blocks eliments
        var ctaBlocks = $ctajobject(".cta-embedded-blocks");
        var ctaWidgets = ctaAppSettings.widget_testimonials;
        
        if (ctaBlocks.length > 0) {
          var ctaLayoutHtml = '';
          $ctajobject(ctaBlocks).each(function () {
            var ctaCurrentBlock = $ctajobject(this);
            $ctajobject(ctaWidgets).each(function (index, ctaWidget) {
              //console.log(ctaWidget);
              if (ctaCurrentBlock.attr('id') == ctaWidget.uuid) {
                var ctaWidgetLayout = parseInt(ctaWidget.layout);
                //console.log(ctaWidget.title);
                var ctaWidgetTitle = "";
                if (ctaWidget.title != '' && ctaWidget.title != null) {
                  ctaWidgetTitle = '<h2 class="cta-title">' + ctaWidget.title + '</h2>';
                }
  
                switch (ctaWidgetLayout) {
                    case 1:
                      ctaLayoutHtml = ctaCarousel(ctaWidgetTitle, ctaCurrentBlock.attr('id'));
                      var ctaCarouselHtml = ctaCarouselLoop(ctaWidget);
                      //ctaLayoutHtml = ctaLayoutHtml.replace("{{cta-testimonial}}", ctaCarouselHtml);
                      ctaLayoutHtml = ctaLayoutHtml.replace("{{cta-testimonial}}", ctaCarouselHtml);
                      ctaLoadSlider(1, ctaCurrentBlock.attr('id'));
                    break;
                    case 2:
                      ctaLayoutHtml = ctaGreed(ctaWidgetTitle, ctaCurrentBlock.attr('id'));
                      var ctaGreedHtml = ctaGreedLoop(ctaWidget);
                      ctaLayoutHtml = ctaLayoutHtml.replace("{{cta-testimonial}}", ctaGreedHtml);
                    break;
                    case 3:
                      ctaLayoutHtml = ctaSlider(ctaWidgetTitle, ctaCurrentBlock.attr('id'));
                      var ctaSliderHtml = ctaSliderLoop(ctaWidget);
                      ctaLayoutHtml = ctaLayoutHtml.replace("{{cta-testimonial}}", ctaSliderHtml);
                      ctaLoadSlider(2, ctaCurrentBlock.attr('id'));
                    break;
                    case 4:
                      ctaLayoutHtml = ctaSlider2(ctaWidgetTitle, ctaCurrentBlock.attr('id'));
                      var ctaSliderHtml = ctaSliderLoop(ctaWidget);
                      ctaLayoutHtml = ctaLayoutHtml.replace("{{cta-testimonial}}", ctaSliderHtml);
                      ctaLoadSlider(3, ctaCurrentBlock.attr('id'));
                    break;
                    case 5:
                    //ctaLayoutHtml = ctaLayoutFive(ctaWidgetTitle, ctaCurrentBlock.attr('id'));
                      ctaLayoutHtml = ctaSlider3(ctaWidgetTitle, ctaCurrentBlock.attr('id'));
                      var ctaSliderHtml = ctaLayoutFive(ctaWidget);
                      ctaLayoutHtml = ctaLayoutHtml.replace("{{cta-testimonial}}", ctaSliderHtml);
                      ctaLoadSlider(2, ctaCurrentBlock.attr('id'));
                    break;
                    case 6:
                      ctaLayoutHtml = ctaSlider4(ctaWidgetTitle, ctaCurrentBlock.attr('id'));
                      var ctaSliderHtml = ctaLayoutSix(ctaWidget);
                      ctaLayoutHtml = ctaLayoutHtml.replace("{{cta-testimonial}}", ctaSliderHtml);
                      ctaLoadSlider(3, ctaCurrentBlock.attr('id'));
                    break;
                    default:
                    // do Nothing
                }
                ctaCurrentBlock.append(ctaLayoutHtml);

                //After load Hook 
                if ($ctajobject.isFunction(window.ctaAfterLoadHook)) {
                  ctaAfterLoadHook();
                }
              }
            });
          });
        }
      }
  
      function ctaGreed(ctaWidget, ctaWidgetID) {
        var ctaGreedTestimonialWrapper = '<div class="testimonial-1">' +
          '<div class="cta-container">' +
          ctaWidget +
          '<div class="t-bq-section cta-greed-' + ctaWidgetID + '" id="jasper">{{cta-testimonial}}</div>' +
          '</div>' +
          '</div>';
        return ctaGreedTestimonialWrapper;
      }
      function ctaCarousel(ctaWidget, ctaWidgetID) {
        var ctaCarouselTestimonialWrapper = '<div class="slider-main">' +
          '<div class="cta-container">' +
          ctaWidget +
          '<div class="cta-slider-' + ctaWidgetID + '">{{cta-testimonial}}</div>' +
          '</div>' +
          '</div>';
        return ctaCarouselTestimonialWrapper;
      }
      function ctaSlider(ctaWidget, ctaWidgetID) {
        var ctaGreedTestimonialWrapper = '<div class="testimonial-3">' +
          '<div class="cta-container">' +
          ctaWidget +
          '<div class="cta-slider-' + ctaWidgetID + '">{{cta-testimonial}}</div>' +
          '</div>' +
          '</div>';
        return ctaGreedTestimonialWrapper;
      }
      function ctaSlider2(ctaWidget, ctaWidgetID) {
        var ctaGreedTestimonialWrapper = '<div class="testimonial-4">' +
          '<div class="cta-container">' +
          ctaWidget +
          '<div class="cta-slider-' + ctaWidgetID + '">{{cta-testimonial}}</div>' +
          '</div>' +
          '</div>';
        return ctaGreedTestimonialWrapper;
      }
      function ctaSlider3(ctaWidget, ctaWidgetID) {
        var ctaGreedTestimonialWrapper = '<div class="testimonial-5">' +
          '<div class="cta-container">' +
          ctaWidget +
          '<div class="cta-slider-' + ctaWidgetID + '">{{cta-testimonial}}</div>' +
          '</div>' +
          '</div>';
        return ctaGreedTestimonialWrapper;
      }
      function ctaSlider4(ctaWidget, ctaWidgetID) {
        var ctaGreedTestimonialWrapper = '<div class="testimonial-6">' +
          '<div class="cta-container">' +
          ctaWidget +
          '<div class="cta-slider-' + ctaWidgetID + '">{{cta-testimonial}}</div>' +
          '</div>' +
          '</div>';
        return ctaGreedTestimonialWrapper;
      }
      function ctaGreedLoop(ctaWidget) {
        //console.log(ctaWidget.testimonials);
        var ctaTestimonialData = ctaWidget.testimonials;
        var ctaGreedTestimonial = "";
        if (ctaTestimonialData != '' && ctaTestimonialData != null) {
  
          $ctajobject(ctaTestimonialData).each(function (index, ctaSingleTestimonial) {
            var ctaClientName = ctaSingleTestimonial.client_name;
            var ctaContent = ctaSingleTestimonial.content;
            var ctaProfilePicture = '';
            var ctaLogoPicture = "";
  
            var ctaUrl = ctaSingleTestimonial.url;
            var ctaClientDesignation = "";
            if(ctaSingleTestimonial.profile_image != '' && ctaSingleTestimonial.profile_image != null ){
              ctaProfilePicture = ctaReplaceimagePath(ctaImageBasepath+ctaSingleTestimonial.profile_image);
            }else{
              ctaProfilePicture = ctaDefaultImage;
            }
  
            if (ctaSingleTestimonial.logo_image != '' && ctaSingleTestimonial.logo_image != null) {
              if (ctaUrl != '' && ctaUrl != null) {
                ctaLogoPicture = '<a href="' + ctaUrl + '" target="_blank"><img class="cta-logo-image" src="' + ctaReplaceimagePath(ctaImageBasepath + ctaSingleTestimonial.logo_image) + '"></a>';
              } else {
                ctaLogoPicture = '<img class="cta-logo-image" src="' + ctaReplaceimagePath(ctaImageBasepath + ctaSingleTestimonial.logo_image) + '">';
              }
  
            } else{
              ctaLogoPicture = '';
            }
  
            var ctaRating = '';
            for (var ctaRatingCount = 0; ctaRatingCount < ctaSingleTestimonial.rating; ctaRatingCount++) {
              ctaRating += '<svg  x-state:on="Starred" x-state:off="Not Starred" x-state-description="Starred: &quot;text-yellow-300 hover:text-yellow-400&quot;, Not Starred: &quot;text-gray-300 hover:text-gray-400&quot;" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
                '<path fill-rule="evenodd" d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z" clip-rule="evenodd"></path>' +
                '</svg>';
            }
  
            if(ctaSingleTestimonial.client_designation != '' && ctaSingleTestimonial.client_designation != null ){
              ctaClientDesignation = ctaSingleTestimonial.client_designation;
            }else{
              ctaClientDesignation = '';
            }
          
            ctaGreedTestimonial += '<div class="t-bq-wrapper t-bq-wrapper-boxed">' +
              '<div class="t-bq-quote t-bq-quote-jasper">' +
              '<div class="t-bq-quote-jasper-pattern">' +
              '<div class="t-bq-quote-jasper-qmark">' +
              '&#10077;' +
              '</div>' +
              '</div>' +
              '<div class="t-bq-quote-jasper-userpic"><div class="cta-profile-image bg-img" style="background-image: url(\'' + ctaProfilePicture + '\')"></div></div>' +
              '<div class="t-bq-quote-jasper-base">' +
              '<blockquote class="t-bq-quote-jasper-text" cite="Strugatsky Brothers">' + ctaContent + '</blockquote>' +
              '<div class="rating">' + ctaRating +
              '</div>' +
              '<div class="t-bq-quote-jasper-meta">' +
              '<div class="t-bq-quote-jasper-meta-info">' +
              '<div class="t-bq-quote-jasper-source">' + ctaLogoPicture + '</div>' +
              '<div class="t-bq-quote-jasper-author"><cite>' + ctaClientName + '</cite></div>' +
              '<div class="t-bq-quote-jasper-source"><span>' + ctaClientDesignation + '</span></div>'+
              '</div>' +
              '</div>' +
              '</div>' +
              '</div>' +
              '</div>';
          });
        }
        return ctaGreedTestimonial;
      }
      function ctaSliderLoop(ctaWidget) {
        var ctaTestimonialData = ctaWidget.testimonials;
        var ctaSliderTestimonial = "";
        if (ctaTestimonialData != '' && ctaTestimonialData != null) {
          $ctajobject(ctaTestimonialData).each(function (index, ctaSingleTestimonial) {
            var ctaClientName = ctaSingleTestimonial.client_name;
            var ctaContent = ctaSingleTestimonial.content;
            var ctaProfilePicture = '';
            var ctaLogoPicture = "";
  
            var ctaUrl = ctaSingleTestimonial.url;
            var ctaClientDesignation = "";
  
            if(ctaSingleTestimonial.profile_image != '' && ctaSingleTestimonial.profile_image != null ){
              ctaProfilePicture = ctaReplaceimagePath(ctaImageBasepath+ctaSingleTestimonial.profile_image);
            }else{
              ctaProfilePicture = '';
            }
  
            if (ctaSingleTestimonial.logo_image != '' && ctaSingleTestimonial.logo_image != null) {
              if (ctaUrl != '' && ctaUrl != null) {
                ctaLogoPicture = '<a href="' + ctaUrl + '" target="_blank"><img class="cta-logo-image" src="' + ctaReplaceimagePath(ctaImageBasepath + ctaSingleTestimonial.logo_image) + '"></a>';
              } else {
                ctaLogoPicture = '<img class="cta-logo-image" src="' + ctaReplaceimagePath(ctaImageBasepath + ctaSingleTestimonial.logo_image) + '">';
              }
  
            } else{
              ctaLogoPicture ='';
            }
  
            var ctaRating = '';
            for (var ctaRatingCount = 0; ctaRatingCount < ctaSingleTestimonial.rating; ctaRatingCount++) {
              ctaRating += '<svg  x-state:on="Starred" x-state:off="Not Starred" x-state-description="Starred: &quot;text-yellow-300 hover:text-yellow-400&quot;, Not Starred: &quot;text-gray-300 hover:text-gray-400&quot;" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
                '<path fill-rule="evenodd" d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z" clip-rule="evenodd"></path>' +
                '</svg>';
            }
  
            if(ctaSingleTestimonial.client_designation != '' && ctaSingleTestimonial.client_designation != null ){
              ctaClientDesignation = ctaSingleTestimonial.client_designation;
            }else{
              ctaClientDesignation = '';
            }

            if(ctaProfilePicture != ''){
              ctaProfilePicture = '<div class="cta-profile-image bg-img" style="background-image: url(\'' + ctaProfilePicture + '\')"></div>';
            }else{
              ctaProfilePicture = '';
            }
            ctaSliderTestimonial += '<div class="cta-slider-wrapper testimonial-box">' +
              ctaLogoPicture +
              '<p class="cta-content-wrapper">' + ctaContent + '</p>' +
              '<div class="rating">' +
              ctaRating +
              '</div>' +
              '<div class="namebox">' +
              ctaProfilePicture +
              '<div class="name">' +
              '<h4>' + ctaClientName + '</h4>' +
              '<p>'+ ctaClientDesignation +'</p>'+
              '</div>' +
              '</div>' +
              '</div>';
  
          });
        }
        return ctaSliderTestimonial;
      }
      function ctaCarouselLoop(ctaWidget) {
        var ctaTestimonialData = ctaWidget.testimonials;
        var ctaCarouselTestimonial = "";
  
        if (ctaTestimonialData != '' && ctaTestimonialData != null) {
          $ctajobject(ctaTestimonialData).each(function (index, ctaSingleTestimonial) {
            var ctaClientName = ctaSingleTestimonial.client_name;
            var ctaContent = ctaSingleTestimonial.content;
            var ctaProfilePicture = '';
            var ctaLogoPicture = "";
            var ctaUrl = ctaSingleTestimonial.url;
            var ctaClientDesignation = "";
  
            if(ctaSingleTestimonial.profile_image != '' && ctaSingleTestimonial.profile_image != null ){
              ctaProfilePicture = ctaReplaceimagePath(ctaImageBasepath+ctaSingleTestimonial.profile_image);
            }else{
              ctaProfilePicture = '';
            }
  
            if (ctaSingleTestimonial.logo_image != '' && ctaSingleTestimonial.logo_image != null) {
              if (ctaUrl != '' && ctaUrl != null) {
                ctaLogoPicture = '<a href="' + ctaUrl + '" target="_blank"><img class="cta-logo-image" src="' + ctaReplaceimagePath(ctaImageBasepath + ctaSingleTestimonial.logo_image) + '"></a>';
              } else {
                ctaLogoPicture = '<img src="' + ctaReplaceimagePath(ctaImageBasepath + ctaSingleTestimonial.logo_image) + '">';
              }
  
            }else{
              ctaLogoPicture = '';
            }
  
            var ctaRating = '';
            for (var ctaRatingCount = 0; ctaRatingCount < ctaSingleTestimonial.rating; ctaRatingCount++) {
              ctaRating += '<svg  x-state:on="Starred" x-state:off="Not Starred" x-state-description="Starred: &quot;text-yellow-300 hover:text-yellow-400&quot;, Not Starred: &quot;text-gray-300 hover:text-gray-400&quot;" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
                '<path fill-rule="evenodd" d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z" clip-rule="evenodd"></path>' +
                '</svg>';
            }
  
            if(ctaSingleTestimonial.client_designation != '' && ctaSingleTestimonial.client_designation != null ){
              ctaClientDesignation = ctaSingleTestimonial.client_designation;
            }else{
              ctaClientDesignation = '';
            }
            
  
            if(ctaProfilePicture != ""){
              ctaProfilePicture ='<img class="cta-profile-image" src="' + ctaProfilePicture + '">';
            }else{
              ctaProfilePicture = '';
            }
            ctaCarouselTestimonial += '<div class="element">' +
              '<div class="cart-main">' +
              '<div class="image-box">' +
              ctaProfilePicture +
              '</div>' +
              '<div class="text-box">' +
              '<svg class="blockquote" viewBox="0 0 162 128" fill="none" aria-hidden="true">' +
              '<path id="b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb" d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z"></path>' +
              '<use href="#b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb" x="86"></use>' +
              '</svg>' +
              '<p class="cta-content-wrapper">' + ctaContent + '</p>' +
              ctaLogoPicture +
              '<div class="name">' +
              '<h4>' + ctaClientName + '</h4>' +
              '<p>'+ ctaClientDesignation +'</p>'+
              '<div class="rating">' +
              ctaRating +
              '</div>' +
              '</div>' +
              '</div>' +
              '</div>' +
              '</div>';
  
          });
        }
        return ctaCarouselTestimonial;
      }
  
      function ctaLayoutFive(ctaWidget) {
          var ctaTestimonialData = ctaWidget.testimonials;
          var ctaCarouselTestimonial = "";
          if (ctaTestimonialData != '' && ctaTestimonialData != null) {
            $ctajobject(ctaTestimonialData).each(function (index, ctaSingleTestimonial) {
    
              var ctaClientName = ctaSingleTestimonial.client_name;
              var ctaContent = ctaSingleTestimonial.content;
              var ctaProfilePicture = '';
              var ctaLogoPicture = "";
              var ctaUrl = ctaSingleTestimonial.url;
              var ctaClientDesignation = "";
    
              var ctaRating = '';
              for (var ctaRatingCount = 0; ctaRatingCount < ctaSingleTestimonial.rating; ctaRatingCount++) {
                ctaRating += '<svg  x-state:on="Starred" x-state:off="Not Starred" x-state-description="Starred: &quot;text-yellow-300 hover:text-yellow-400&quot;, Not Starred: &quot;text-gray-300 hover:text-gray-400&quot;" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
                  '<path fill-rule="evenodd" d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z" clip-rule="evenodd"></path>' +
                  '</svg>';
              }
    
              ctaCarouselTestimonial +='<div class="box">'+
                                            '<div class="t-box-qmark">'+
                                                '&#10077;'+
                                            '</div>'+
                                            '<p class="cta-content-wrapper">'+ctaContent+'</p>'+
                                            '<span></span>'+
                                            '<div class="name">'+
                                                '<h5>- '+ ctaClientName +'</h5>'+
                                                '<div class="rating">'+ctaRating+'</div>'+
                                            '</div>'+
                                        '</div>';
            });
            
          }
          return ctaCarouselTestimonial;
      }

      function ctaLayoutSix(ctaWidget) {
      
        var ctaTestimonialData = ctaWidget.testimonials;
        var ctaCarouselTestimonial = "";
        var ctaColorCombination = [
          "pink",
          "pista",
          "green",
          "blue",
          "yellow"
        ];
        var ctaColorLenth = ctaColorCombination.length;
        var ctaColorRepeater = 0;
        //console.log(ctaColorLenth);
        if (ctaTestimonialData != '' && ctaTestimonialData != null) {
          //console.log(ctaTestimonialData.length);
          $ctajobject(ctaTestimonialData).each(function (index, ctaSingleTestimonial) {
            //console.log("test--"+ index);
              var ctaClientName = ctaSingleTestimonial.client_name;
              var ctaContent = ctaSingleTestimonial.content;
              var ctaProfilePicture = '';
              var ctaLogoPicture = "";
              var ctaUrl = ctaSingleTestimonial.url;
              var ctaClientDesignation = "";
  
              //For Set color
              var ctaColorClass = ctaColorCombination[ctaColorRepeater];
  
              //For repeat color
              if(ctaColorClass === undefined){ 
                  ctaColorRepeater = 0;
                  ctaColorClass = ctaColorCombination[ctaColorRepeater];
              }
                          
              ctaLogoName = ctaAbbreviateWord(ctaClientName);
              
  
              if(ctaSingleTestimonial.profile_image != '' && ctaSingleTestimonial.profile_image != null ){
                ctaProfilePicture = ctaReplaceimagePath(ctaImageBasepath+ctaSingleTestimonial.profile_image);
              }else{
                ctaProfilePicture = ctaDefaultImage;
              }
                
              var ctaRating = '';
              for (var ctaRatingCount = 0; ctaRatingCount < ctaSingleTestimonial.rating; ctaRatingCount++) {
                ctaRating += '<svg  x-state:on="Starred" x-state:off="Not Starred" x-state-description="Starred: &quot;text-yellow-300 hover:text-yellow-400&quot;, Not Starred: &quot;text-gray-300 hover:text-gray-400&quot;" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
                  '<path fill-rule="evenodd" d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z" clip-rule="evenodd"></path>' +
                  '</svg>';
              }
    
              if(ctaSingleTestimonial.client_designation != '' && ctaSingleTestimonial.client_designation != null ){
                ctaClientDesignation = ctaSingleTestimonial.client_designation;
              }else{
                ctaClientDesignation = '';
              }
  
              ctaCarouselTestimonial +='<div class="testimonial-box box-'+ctaColorClass+'">'+
                                          '<p class="cta-content-wrapper">'+ctaContent+'</p>'+
                                          '<div class="rating">'+
                                              '<div class="namebox">'+
                                                  '<div class="namelogo">'+
                                                      '<a href="#" class="alpha logo-'+ctaColorClass+'">'+ctaLogoName+'</a>'+
                                                  '</div>'+
                                                  '<div class="name">'+
                                                      '<h5>'+ ctaClientName +'</h5>'+
                                                  '</div>'+
                                              '</div>'+
                                              '<div class="star">'+ctaRating+'</div>'+
                                          '</div>'+
                                      '</div>';
            ctaColorRepeater = parseInt(ctaColorRepeater) + 1;
            
          });
        }
        return ctaCarouselTestimonial;
      }

      function ctaAbbreviateWord(ctaName){
        var ctaWords = ctaName.split(' ');
        var ctaAbbreviation = '';
        for (var i = 0; i < ctaWords.length; i++) {
            if (ctaWords[i]) { 
               ctaAbbreviation += ctaWords[i][0].toUpperCase();
            }
        }
        return ctaAbbreviation;
      }

      function ctaLoadSlider(ptaItem, ctaWidgetID) {
        !function (e, i) { "use strict"; var t = { item: 3, autoWidth: !1, slideMove: 1, slideMargin: 10, addClass: "", mode: "slide", useCSS: !0, cssEasing: "ease", easing: "linear", speed: 400, auto: !1, pauseOnHover: !1, loop: !1, slideEndAnimation: !0, pause: 2e3, keyPress: !1, controls: !0, prevHtml: "", nextHtml: "", rtl: !1, adaptiveHeight: !1, vertical: !1, verticalHeight: 500, vThumbWidth: 100, thumbItem: 10, pager: !0, gallery: !1, galleryMargin: 5, thumbMargin: 5, currentPagerPosition: "middle", enableTouch: !0, enableDrag: !0, freeMove: !0, swipeThreshold: 40, responsive: [], onBeforeStart: function (e) { }, onSliderLoad: function (e) { }, onBeforeSlide: function (e, i) { }, onAfterSlide: function (e, i) { }, onBeforeNextSlide: function (e, i) { }, onBeforePrevSlide: function (e, i) { } }; e.fn.lightSlider = function (i) { if (0 === this.length) return this; if (this.length > 1) return this.each(function () { e(this).lightSlider(i) }), this; var n = {}, l = e.extend(!0, {}, t, i), a = {}, s = this; n.$el = this, "fade" === l.mode && (l.vertical = !1); var o = s.children(), r = e(window).width(), d = null, c = null, u = 0, f = 0, h = !1, g = 0, v = "", p = 0, $ = !0 === l.vertical ? "height" : "width", m = !0 === l.vertical ? "margin-bottom" : "margin-right", S = 0, _ = 0, b = 0, C = 0, M = null, T = "ontouchstart" in document.documentElement, x = {}; return x.chbreakpoint = function () { if (r = e(window).width(), l.responsive.length) { var i; if (!1 === l.autoWidth && (i = l.item), r < l.responsive[0].breakpoint) for (var t = 0; t < l.responsive.length; t++)r < l.responsive[t].breakpoint && (d = l.responsive[t].breakpoint, c = l.responsive[t]); if (null != c) for (var n in c.settings) c.settings.hasOwnProperty(n) && ((void 0 === a[n] || null === a[n]) && (a[n] = l[n]), l[n] = c.settings[n]); if (!e.isEmptyObject(a) && r > l.responsive[0].breakpoint) for (var s in a) a.hasOwnProperty(s) && (l[s] = a[s]); !1 === l.autoWidth && S > 0 && b > 0 && i !== l.item && (p = Math.round(S / ((b + l.slideMargin) * l.slideMove))) } }, x.calSW = function () { !1 === l.autoWidth && (b = (g - (l.item * l.slideMargin - l.slideMargin)) / l.item) }, x.calWidth = function (e) { var i = !0 === e ? v.find(".lslide").length : o.length; if (!1 === l.autoWidth) f = i * (b + l.slideMargin); else { f = 0; for (var t = 0; t < i; t++)f += parseInt(o.eq(t).width()) + l.slideMargin } return f }, (n = { doCss: function () { return !!(l.useCSS && function () { for (var e = ["transition", "MozTransition", "WebkitTransition", "OTransition", "msTransition", "KhtmlTransition"], i = document.documentElement, t = 0; t < e.length; t++)if (e[t] in i.style) return !0 }()) }, keyPress: function () { l.keyPress && e(document).on("keyup.lightslider", function (i) { e(":focus").is("input, textarea") || (i.preventDefault ? i.preventDefault() : i.returnValue = !1, 37 === i.keyCode ? s.goToPrevSlide() : 39 === i.keyCode && s.goToNextSlide()) }) }, controls: function () { l.controls && (s.after('<div class="lSAction"><a class="lSPrev">' + l.prevHtml + '</a><a class="lSNext">' + l.nextHtml + "</a></div>"), l.autoWidth ? x.calWidth(!1) < g && v.find(".lSAction").hide() : u <= l.item && v.find(".lSAction").hide(), v.find(".lSAction a").on("click", function (i) { return i.preventDefault ? i.preventDefault() : i.returnValue = !1, "lSPrev" === e(this).attr("class") ? s.goToPrevSlide() : s.goToNextSlide(), !1 })) }, initialStyle: function () { var e = this; "fade" === l.mode && (l.autoWidth = !1, l.slideEndAnimation = !1), l.auto && (l.slideEndAnimation = !1), l.autoWidth && (l.slideMove = 1, l.item = 1), l.loop && (l.slideMove = 1, l.freeMove = !1), l.onBeforeStart.call(this, s), x.chbreakpoint(), s.addClass("lightSlider").wrap('<div class="lSSlideOuter ' + l.addClass + '"><div class="lSSlideWrapper"></div></div>'), v = s.parent(".lSSlideWrapper"), !0 === l.rtl && v.parent().addClass("lSrtl"), l.vertical ? (v.parent().addClass("vertical"), g = l.verticalHeight, v.css("height", g + "px")) : g = s.outerWidth(), o.addClass("lslide"), !0 === l.loop && "slide" === l.mode && (x.calSW(), x.clone = function () { if (x.calWidth(!0) > g) { for (var i = 0, t = 0, n = 0; n < o.length && (i += parseInt(s.find(".lslide").eq(n).width()) + l.slideMargin, t++, !(i >= g + l.slideMargin)); n++); var a = !0 === l.autoWidth ? t : l.item; if (a < s.find(".clone.left").length) for (var r = 0; r < s.find(".clone.left").length - a; r++)o.eq(r).remove(); if (a < s.find(".clone.right").length) for (var d = o.length - 1; d > o.length - 1 - s.find(".clone.right").length; d--)p--, o.eq(d).remove(); for (var c = s.find(".clone.right").length; c < a; c++)s.find(".lslide").eq(c).clone().removeClass("lslide").addClass("clone right").appendTo(s), p++; for (var u = s.find(".lslide").length - s.find(".clone.left").length; u > s.find(".lslide").length - a; u--)s.find(".lslide").eq(u - 1).clone().removeClass("lslide").addClass("clone left").prependTo(s); o = s.children() } else o.hasClass("clone") && (s.find(".clone").remove(), e.move(s, 0)) }, x.clone()), x.sSW = function () { u = o.length, !0 === l.rtl && !1 === l.vertical && (m = "margin-left"), !1 === l.autoWidth && o.css($, b + "px"), o.css(m, l.slideMargin + "px"), f = x.calWidth(!1), s.css($, f + "px"), !0 === l.loop && "slide" === l.mode && !1 === h && (p = s.find(".clone.left").length) }, x.calL = function () { u = (o = s.children()).length }, this.doCss() && v.addClass("usingCss"), x.calL(), "slide" === l.mode ? (x.calSW(), x.sSW(), !0 === l.loop && (S = e.slideValue(), this.move(s, S)), !1 === l.vertical && this.setHeight(s, !1)) : (this.setHeight(s, !0), s.addClass("lSFade"), this.doCss() || (o.fadeOut(0), o.eq(p).fadeIn(0))), !0 === l.loop && "slide" === l.mode ? o.eq(p).addClass("active") : o.first().addClass("active") }, pager: function () { var e = this; if (x.createPager = function () { C = (g - (l.thumbItem * l.thumbMargin - l.thumbMargin)) / l.thumbItem; var i = v.find(".lslide"), t = v.find(".lslide").length, n = 0, a = "", o = 0; for (n = 0; n < t; n++) { "slide" === l.mode && (l.autoWidth ? o += (parseInt(i.eq(n).width()) + l.slideMargin) * l.slideMove : o = n * ((b + l.slideMargin) * l.slideMove)); var r = i.eq(n * l.slideMove).attr("data-thumb"); if (!0 === l.gallery ? a += '<li style="width:100%;' + $ + ":" + C + "px;" + m + ":" + l.thumbMargin + 'px"><a href="#"><img src="' + r + '" /></a></li>' : a += '<li><a href="#">' + (n + 1) + "</a></li>", "slide" === l.mode && o >= f - g - l.slideMargin) { n += 1; var d = 2; l.autoWidth && (a += '<li><a href="#">' + (n + 1) + "</a></li>", d = 1), n < d ? (a = null, v.parent().addClass("noPager")) : v.parent().removeClass("noPager"); break } } var c = v.parent(); c.find(".lSPager").html(a), !0 === l.gallery && (!0 === l.vertical && c.find(".lSPager").css("width", l.vThumbWidth + "px"), _ = n * (l.thumbMargin + C) + .5, c.find(".lSPager").css({ property: _ + "px", "transition-duration": l.speed + "ms" }), !0 === l.vertical && v.parent().css("padding-right", l.vThumbWidth + l.galleryMargin + "px"), c.find(".lSPager").css($, _ + "px")); var u = c.find(".lSPager").find("li"); u.first().addClass("active"), u.on("click", function () { return !0 === l.loop && "slide" === l.mode ? p += u.index(this) - c.find(".lSPager").find("li.active").index() : p = u.index(this), s.mode(!1), !0 === l.gallery && e.slideThumb(), !1 }) }, l.pager) { var i = "lSpg"; l.gallery && (i = "lSGallery"), v.after('<ul class="lSPager ' + i + '"></ul>'); var t = l.vertical ? "margin-left" : "margin-top"; v.parent().find(".lSPager").css(t, l.galleryMargin + "px"), x.createPager() } setTimeout(function () { x.init() }, 0) }, setHeight: function (e, i) { var t = null, n = this; t = l.loop ? e.children(".lslide ").first() : e.children().first(); var a = function () { var n = t.outerHeight(), l = 0, a = n; i && (n = 0, l = 100 * a / g), e.css({ height: n + "px", "padding-bottom": l + "%" }) }; a(), t.find("img").length ? t.find("img")[0].complete ? (a(), M || n.auto()) : t.find("img").on("load", function () { setTimeout(function () { a(), M || n.auto() }, 100) }) : M || n.auto() }, active: function (e, i) { this.doCss() && "fade" === l.mode && v.addClass("on"); var t, n, a = 0; p * l.slideMove < u ? (e.removeClass("active"), this.doCss() || "fade" !== l.mode || !1 !== i || e.fadeOut(l.speed), a = !0 === i ? p : p * l.slideMove, !0 === i && (n = (t = e.length) - 1, a + 1 >= t && (a = n)), !0 === l.loop && "slide" === l.mode && (a = !0 === i ? p - s.find(".clone.left").length : p * l.slideMove, !0 === i && (n = (t = e.length) - 1, a + 1 === t ? a = n : a + 1 > t && (a = 0))), this.doCss() || "fade" !== l.mode || !1 !== i || e.eq(a).fadeIn(l.speed), e.eq(a).addClass("active")) : (e.removeClass("active"), e.eq(e.length - 1).addClass("active"), this.doCss() || "fade" !== l.mode || !1 !== i || (e.fadeOut(l.speed), e.eq(a).fadeIn(l.speed))) }, move: function (e, i) { !0 === l.rtl && (i = -i), this.doCss() ? !0 === l.vertical ? e.css({ transform: "translate3d(0px, " + -i + "px, 0px)", "-webkit-transform": "translate3d(0px, " + -i + "px, 0px)" }) : e.css({ transform: "translate3d(" + -i + "px, 0px, 0px)", "-webkit-transform": "translate3d(" + -i + "px, 0px, 0px)" }) : !0 === l.vertical ? e.css("position", "relative").animate({ top: -i + "px" }, l.speed, l.easing) : e.css("position", "relative").animate({ left: -i + "px" }, l.speed, l.easing); var t = v.parent().find(".lSPager").find("li"); this.active(t, !0) }, fade: function () { this.active(o, !1); var e = v.parent().find(".lSPager").find("li"); this.active(e, !0) }, slide: function () { var e = this; x.calSlide = function () { f > g && (S = e.slideValue(), e.active(o, !1), S > f - g - l.slideMargin ? S = f - g - l.slideMargin : S < 0 && (S = 0), e.move(s, S), !0 === l.loop && "slide" === l.mode && (p >= u - s.find(".clone.left").length / l.slideMove && e.resetSlide(s.find(".clone.left").length), 0 === p && e.resetSlide(v.find(".lslide").length))) }, x.calSlide() }, resetSlide: function (e) { var i = this; v.find(".lSAction a").addClass("disabled"), setTimeout(function () { p = e, v.css("transition-duration", "0ms"), S = i.slideValue(), i.active(o, !1), n.move(s, S), setTimeout(function () { v.css("transition-duration", l.speed + "ms"), v.find(".lSAction a").removeClass("disabled") }, 50) }, l.speed + 100) }, slideValue: function () { var e = 0; if (!1 === l.autoWidth) e = p * ((b + l.slideMargin) * l.slideMove); else { e = 0; for (var i = 0; i < p; i++)e += parseInt(o.eq(i).width()) + l.slideMargin } return e }, slideThumb: function () { switch (l.currentPagerPosition) { case "left": e = 0; break; case "middle": e = g / 2 - C / 2; break; case "right": e = g - C }var e, i = p - s.find(".clone.left").length, t = v.parent().find(".lSPager"); "slide" === l.mode && !0 === l.loop && (i >= t.children().length ? i = 0 : i < 0 && (i = t.children().length)); var n = i * (C + l.thumbMargin) - e; n + g > _ && (n = _ - g - l.thumbMargin), n < 0 && (n = 0), this.move(t, n) }, auto: function () { l.auto && (clearInterval(M), M = setInterval(function () { s.goToNextSlide() }, l.pause)) }, pauseOnHover: function () { var i = this; l.auto && l.pauseOnHover && (v.on("mouseenter", function () { e(this).addClass("ls-hover"), s.pause(), l.auto = !0 }), v.on("mouseleave", function () { e(this).removeClass("ls-hover"), v.find(".lightSlider").hasClass("lsGrabbing") || i.auto() })) }, touchMove: function (e, i) { if (v.css("transition-duration", "0ms"), "slide" === l.mode) { var t = S - (e - i); if (t >= f - g - l.slideMargin) { if (!1 === l.freeMove) t = f - g - l.slideMargin; else { var n = f - g - l.slideMargin; t = n + (t - n) / 5 } } else t < 0 && (!1 === l.freeMove ? t = 0 : t /= 5); this.move(s, t) } }, touchEnd: function (e) { if (v.css("transition-duration", l.speed + "ms"), "slide" === l.mode) { var i = !1, t = !0; (S -= e) > f - g - l.slideMargin ? (S = f - g - l.slideMargin, !1 === l.autoWidth && (i = !0)) : S < 0 && (S = 0); var n = function (e) { var t = 0; if (!i && e && (t = 1), l.autoWidth) for (var n = 0, a = 0; a < o.length && (n += parseInt(o.eq(a).width()) + l.slideMargin, p = a + t, !(n >= S)); a++); else { var s = S / ((b + l.slideMargin) * l.slideMove); p = parseInt(s) + t, S >= f - g - l.slideMargin && s % 1 != 0 && p++ } }; e >= l.swipeThreshold ? (n(!1), t = !1) : e <= -l.swipeThreshold && (n(!0), t = !1), s.mode(t), this.slideThumb() } else e >= l.swipeThreshold ? s.goToPrevSlide() : e <= -l.swipeThreshold && s.goToNextSlide() }, enableDrag: function () { var i = this; if (!T) { var t = 0, n = 0, a = !1; v.find(".lightSlider").addClass("lsGrab"), v.on("mousedown", function (i) { if (f < g && 0 !== f) return !1; "lSPrev" !== e(i.target).attr("class") && "lSNext" !== e(i.target).attr("class") && (t = !0 === l.vertical ? i.pageY : i.pageX, a = !0, i.preventDefault ? i.preventDefault() : i.returnValue = !1, v.scrollLeft += 1, v.scrollLeft -= 1, v.find(".lightSlider").removeClass("lsGrab").addClass("lsGrabbing"), clearInterval(M)) }), e(window).on("mousemove", function (e) { a && (n = !0 === l.vertical ? e.pageY : e.pageX, i.touchMove(n, t)) }), e(window).on("mouseup", function (s) { if (a) { v.find(".lightSlider").removeClass("lsGrabbing").addClass("lsGrab"), a = !1; var o = (n = !0 === l.vertical ? s.pageY : s.pageX) - t; Math.abs(o) >= l.swipeThreshold && e(window).on("click.ls", function (i) { i.preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopImmediatePropagation(), i.stopPropagation(), e(window).off("click.ls") }), i.touchEnd(o) } }) } }, enableTouch: function () { var e = this; if (T) { var i = {}, t = {}; v.on("touchstart", function (e) { t = e.originalEvent.targetTouches[0], i.pageX = e.originalEvent.targetTouches[0].pageX, i.pageY = e.originalEvent.targetTouches[0].pageY, clearInterval(M) }), v.on("touchmove", function (n) { if (f < g && 0 !== f) return !1; var a = Math.abs((t = n.originalEvent.targetTouches[0]).pageX - i.pageX), s = Math.abs(t.pageY - i.pageY); !0 === l.vertical ? (3 * s > a && n.preventDefault(), e.touchMove(t.pageY, i.pageY)) : (3 * a > s && n.preventDefault(), e.touchMove(t.pageX, i.pageX)) }), v.on("touchend", function () { var n; if (f < g && 0 !== f) return !1; n = !0 === l.vertical ? t.pageY - i.pageY : t.pageX - i.pageX, e.touchEnd(n) }) } }, build: function () { var i = this; i.initialStyle(), this.doCss() && (!0 === l.enableTouch && i.enableTouch(), !0 === l.enableDrag && i.enableDrag()), e(window).on("focus", function () { i.auto() }), e(window).on("blur", function () { clearInterval(M) }), i.pager(), i.pauseOnHover(), i.controls(), i.keyPress() } }).build(), x.init = function () { x.chbreakpoint(), !0 === l.vertical ? (g = l.item > 1 ? l.verticalHeight : o.outerHeight(), v.css("height", g + "px")) : g = v.outerWidth(), !0 === l.loop && "slide" === l.mode && x.clone(), x.calL(), "slide" === l.mode && s.removeClass("lSSlide"), "slide" === l.mode && (x.calSW(), x.sSW()), setTimeout(function () { "slide" === l.mode && s.addClass("lSSlide") }, 1e3), l.pager && x.createPager(), !0 === l.adaptiveHeight && !1 === l.vertical && s.css("height", o.eq(p).outerHeight(!0)), !1 === l.adaptiveHeight && ("slide" === l.mode ? !1 === l.vertical ? n.setHeight(s, !1) : n.auto() : n.setHeight(s, !0)), !0 === l.gallery && n.slideThumb(), "slide" === l.mode && n.slide(), !1 === l.autoWidth ? o.length <= l.item ? v.find(".lSAction").hide() : v.find(".lSAction").show() : x.calWidth(!1) < g && 0 !== f ? v.find(".lSAction").hide() : v.find(".lSAction").show() }, s.goToPrevSlide = function () { p > 0 ? (l.onBeforePrevSlide.call(this, s, p), p--, s.mode(!1), !0 === l.gallery && n.slideThumb()) : !0 === l.loop ? (l.onBeforePrevSlide.call(this, s, p), "fade" === l.mode && (p = parseInt((u - 1) / l.slideMove)), s.mode(!1), !0 === l.gallery && n.slideThumb()) : !0 === l.slideEndAnimation && (s.addClass("leftEnd"), setTimeout(function () { s.removeClass("leftEnd") }, 400)) }, s.goToNextSlide = function () { var e = !0; "slide" === l.mode && (e = n.slideValue() < f - g - l.slideMargin), p * l.slideMove < u - l.slideMove && e ? (l.onBeforeNextSlide.call(this, s, p), p++, s.mode(!1), !0 === l.gallery && n.slideThumb()) : !0 === l.loop ? (l.onBeforeNextSlide.call(this, s, p), p = 0, s.mode(!1), !0 === l.gallery && n.slideThumb()) : !0 === l.slideEndAnimation && (s.addClass("rightEnd"), setTimeout(function () { s.removeClass("rightEnd") }, 400)) }, s.mode = function (e) { !0 === l.adaptiveHeight && !1 === l.vertical && s.css("height", o.eq(p).outerHeight(!0)), !1 === h && ("slide" === l.mode ? n.doCss() && (s.addClass("lSSlide"), "" !== l.speed && v.css("transition-duration", l.speed + "ms"), "" !== l.cssEasing && v.css("transition-timing-function", l.cssEasing)) : n.doCss() && ("" !== l.speed && s.css("transition-duration", l.speed + "ms"), "" !== l.cssEasing && s.css("transition-timing-function", l.cssEasing))), e || l.onBeforeSlide.call(this, s, p), "slide" === l.mode ? n.slide() : n.fade(), v.hasClass("ls-hover") || n.auto(), setTimeout(function () { e || l.onAfterSlide.call(this, s, p) }, l.speed), h = !0 }, s.play = function () { s.goToNextSlide(), l.auto = !0, n.auto() }, s.pause = function () { l.auto = !1, clearInterval(M) }, s.refresh = function () { x.init() }, s.getCurrentSlideCount = function () { var e = p; if (l.loop) { var i = v.find(".lslide").length, t = s.find(".clone.left").length; e = p <= t - 1 ? i + (p - t) : p >= i + t ? p - i - t : p - t } return e + 1 }, s.getTotalSlideCount = function () { return v.find(".lslide").length }, s.goToSlide = function (e) { p = l.loop ? e + s.find(".clone.left").length - 1 : e, s.mode(!1), !0 === l.gallery && n.slideThumb() }, s.destroy = function () { s.lightSlider && (s.goToPrevSlide = function () { }, s.goToNextSlide = function () { }, s.mode = function () { }, s.play = function () { }, s.pause = function () { }, s.refresh = function () { }, s.getCurrentSlideCount = function () { }, s.getTotalSlideCount = function () { }, s.goToSlide = function () { }, s.lightSlider = null, x = { init: function () { } }, s.parent().parent().find(".lSAction, .lSPager").remove(), s.removeClass("lightSlider lSFade lSSlide lsGrab lsGrabbing leftEnd right").removeAttr("style").unwrap().unwrap(), s.children().removeAttr("style"), o.removeClass("lslide active"), s.find(".clone").remove(), o = null, M = null, h = !1, p = 0) }, setTimeout(function () { l.onSliderLoad.call(this, s) }, 10), e(window).on("resize orientationchange", function (e) { setTimeout(function () { e.preventDefault ? e.preventDefault() : e.returnValue = !1, x.init() }, 200) }), this } }(jQuery);
  
        $ctajobject(document).ready(function () {
          var ptaSliderEliment = ".cta-slider-" + ctaWidgetID;
          
          //Hook for change the slide counts
          if($ctajobject.isFunction(window.ctaModifyItemCount)) {
              if(ctaModifyItemCount(ptaItem)) {
                  ptaItem = ctaModifyItemCount(ptaItem);
              }
          }

          if(ptaItem > 3){
            var ptaScreen991 = 3;
            var ptaScreen800 = 3;
          }else{
            var ptaScreen991 = ptaItem;
            var ptaScreen800 = ptaItem;
          } 

          //Hook for change the slide counts for screen 991
          if($ctajobject.isFunction(window.ctaModifyItemCount991)) {
              if(ctaModifyItemCount991(ptaScreen991)) {
                ptaScreen991 = ctaModifyItemCount991(ptaScreen991);
              }
          }

          //Hook for change the slide counts for screen 800
          if($ctajobject.isFunction(window.ctaModifyItemCount800)) {
            if(ctaModifyItemCount800(ptaScreen800)) {
              ptaScreen800 = ctaModifyItemCount800(ptaScreen800);
            }
          }

          var ctaMobilePagerStatus = false;
          //Hook for Enable dot in mobile
          if($ctajobject.isFunction(window.ctaEnablePagerMobile)) {
            if(ctaEnablePagerMobile(ctaMobilePagerStatus)) {
              ctaMobilePagerStatus = ctaEnablePagerMobile(ctaMobilePagerStatus);
            }
          }

          var ctaLoopStatus = true;
          //Hook for change loop
          if($ctajobject.isFunction(window.ctaLoopStatusChange)) {
          if(ctaLoopStatusChange(ctaLoopStatus)) {
              ctaLoopStatus = ctaLoopStatusChange(ctaLoopStatus);            
          }
          }
          
          ctaLoopStatus = false;

          $ctajobject(ptaSliderEliment).lightSlider({
            loop: ctaLoopStatus,
            item: ptaItem,
            autoWidth: false,  //dynamic variable
            pager: true, //dynamic variable
            controls: true, //dynamic variable
            auto: true, //dynamic variable
            slideMargin: 15,
            speed: 500,
            pause: 4000,
            pauseOnHover: true,
            keyPress: false,
            slideMove: 1,
            rtl: false,
            adaptiveHeight: true,
            slideEndAnimation: false,
            enableDrag: true,
            freeMove:true,
            vertical: false,
            mode: 'slide',
            easing: 'linear',
            cssEasing: 'ease',
            freeMove:true,
            swipeThreshold: 40,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  loop: false,
                  item: ptaScreen991,
                  pager: ctaMobilePagerStatus,
                  slideMove: 1
                }
              },
              {
                breakpoint: 800,
                settings: {
                  loop: false,
                  item: ptaScreen800,
                  pager: ctaMobilePagerStatus,
                  slideMove: 1
                }
              },
              {
                breakpoint: 667,
                settings: {
                  loop: false,
                  item: 1,
                  pager: ctaMobilePagerStatus,
                  slideMove: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  loop: false,
                  item: 1,
                  pager: ctaMobilePagerStatus,
                  slideMove: 1
                }
              }
            ],
            onSliderLoad: function(slider, index) {
              $ctajobject(".cta-embedded-blocks").find(".clone").removeClass("right");
              $ctajobject(".cta-blocks").find('.lslide').each(function() {
                  var fullText = $ctajobject(this).find('.cta-content-wrapper');
                  var textContent = fullText.text();
                  $ctajobject(this).find('.cta-read-more-wrapper').append('<div class="cta-full-text">'+textContent+'</div>');
                  if (textContent.length > 200) {
                      var truncatedText = textContent.slice(0, 200) + '....';
                      $ctajobject(this).find('.cta-content-wrapper').attr('full-text', textContent); 
                      fullText.text(truncatedText);
                      fullText.append(ctaReadmoreHTML);
                  } else {
                  }
              });
            },
            onBeforeSlide: function(slider, index) {
              $ctajobject(".cta-embedded-blocks").find(".clone").removeClass("right");
            }
          });
        });
        return true;
      }

      $ctajobject(document).on("click",".cta-read-more",function() {
          var ctaFullText = $ctajobject(this).parents('.lslide').find('.cta-content-wrapper');
          var ctaFullTextContent = ctaFullText.attr('full-text');
          var currentText = ctaFullText.html();
          currentText = currentText.split("....<span");
          currentText = currentText[0];
          var characterLimit = 200;
          if (parseInt(currentText.length) <= parseInt(characterLimit)) {
            var readLessLabel = '<span class="cta-read-more">Read Less</span>';
            ctaFullText.text(ctaFullTextContent+'....');
            ctaFullText.append(readLessLabel);
          }else{
            var readMoreLabel = '<span class="cta-read-more">Read More</span>';
            var shortText = ctaFullTextContent.slice(0, 200) + '....';
            ctaFullText.text(shortText);
            ctaFullText.append(readMoreLabel);
          }
      });

      function ctaReplaceimagePath(ctaImgpath){
        return ctaImgpath.replace('images/backend/testimonial/','');
      }

      $ctajobject('div').ctaLoad();
    })(window.jQuery, window, document);
  
  });
}